import type { Action } from "../../actions/types";
import get from "lodash/get";

export interface StoreState {
  status: string;
  coupon?: string;
}

export const initialState: StoreState = { status: "pending" };

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "EVENT_SUCCESS":
      // if the event comes back with a preReward coupon code we'll use it
      const coupon = get(action, "response.data.event.preReward.couponCode");
      if (coupon) {
        return { coupon, status: "success" };
      }

      return state;

    case "GET_COUPON_SUCCESS":
      const status = get(action, "response.data.status");
      if (status === "success") {
        return { coupon: action.response.data.coupon, status };
      } else {
        return { status };
      }

    case "EXCHANGE_REDEEM_SUCCESS":
      const code = get(
        action,
        "response.data.transaction.transaction.definition.code"
      );

      return { coupon: code, status: "success" };

    default:
      return state;
  }
}
